// removed by extract-text-webpack-plugin
module.exports = {"theme":"#59B99C","themeBg":"#EFFFDC","textColor":"#A54C29","subTextColor":"#999","activeColor":"#fff","bodyBg":"#EFFFDC"};


//////////////////
// WEBPACK FOOTER
// ./src/style/index.scss
// module id = +qiL
// module chunks = 24